import React from 'react';
import PropTypes from 'prop-types';

import ButtonProgress from '../../../commons/ButtonProgress';
import { getTaxLabel } from '../../../conf/chargify';
import { useStyles } from '../checkoutDrawer.styles';
import OrderSummary from '../sections/OrderSummary';
import PromoCode from '../sections/PromoCode';
import ChargifyPanel from '../sections/ChargifyPanel';
import BillingAddress from '../sections/BillingAddress';
import TermsConsentNotice from '../../TermsConsentNotice';

function CheckoutForm ({ state, plan, showBasePrice, showPromo, payLabel }) {
    const classes = useStyles();

    const {
        formRef,
        tokenizing,
        form,
        states,
        fieldErrors,
        submitError,
        canPay,
        initChargify,
        setField,
        handleBlur,
        handleApplyPromo,
        handleRemovePromo,
        handleSubmit,
        handleCancel,
        getBasePrice,
        getEffectivePrice,
        getDiscountAmount,
        getAddOnsSummary,
        getTaxRate,
        getSubTotal,
        getTaxValue,
        getTotalRecurring,
        previewLoading,
        formatPrice,
        formatPriceUnit,
    } = state;

    const basePrice = getBasePrice();
    const effectivePrice = getEffectivePrice();
    const discountAmount = getDiscountAmount();
    const addOnsSummary = getAddOnsSummary();
    const subTotal = getSubTotal();
    const taxRate = getTaxRate();
    const taxValue = getTaxValue();
    const totalRecurring = getTotalRecurring();
    const taxLabel = getTaxLabel(plan.price && plan.price.currency);
    const planNameUpper = (plan.name || '').toUpperCase();

    return (
        <React.Fragment>
            <div className={classes.body}>
                {submitError && (
                    <div className={classes.errorBanner} role="alert">
                        {submitError}
                    </div>
                )}

                <OrderSummary
                    plan={plan}
                    planNameUpper={planNameUpper}
                    basePrice={basePrice}
                    showBasePrice={showBasePrice}
                    effectivePrice={effectivePrice}
                    discountAmount={discountAmount}
                    promoApplied={form.promoApplied}
                    addOns={addOnsSummary.addOns}
                    subTotal={subTotal}
                    taxLabel={taxLabel}
                    taxRate={taxRate}
                    taxValue={taxValue}
                    totalRecurring={totalRecurring}
                    previewLoading={previewLoading}
                    formatPriceUnit={formatPriceUnit}
                />

                {showPromo && (
                    <PromoCode
                        form={form}
                        setField={setField}
                        handleApplyPromo={handleApplyPromo}
                        handleRemovePromo={handleRemovePromo}
                        formatPrice={formatPrice}
                    />
                )}

                <div>
                    <p className={classes.sectionLabel}>Card details</p>
                    <ChargifyPanel
                        formRef={formRef}
                        form={form}
                        initChargify={initChargify}
                    />
                </div>

                <BillingAddress
                    form={form}
                    fieldErrors={fieldErrors}
                    states={states}
                    setField={setField}
                    handleBlur={handleBlur}
                />

                <TermsConsentNotice marginBottom={20} />
            </div>

            <div className={classes.footer}>
                <button className={classes.cancelBtn} onClick={handleCancel} type="button">
                    CANCEL
                </button>
                <div style={{ flex: 1 }}>
                    <ButtonProgress
                        showProgress={tokenizing}
                        onClick={handleSubmit}
                        disabled={!canPay}
                        label={`PAY ${formatPrice(effectivePrice)} · ${payLabel}`}
                        className={classes.payBtn}
                        width="100%"
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

CheckoutForm.propTypes = {
    state: PropTypes.object.isRequired,
    plan: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
    }).isRequired,
    showBasePrice: PropTypes.bool,
    showPromo: PropTypes.bool,
    addOnsOnly: PropTypes.bool,
    payLabel: PropTypes.string,
};

CheckoutForm.defaultProps = {
    showBasePrice: true,
    showPromo: true,
    addOnsOnly: false,
    payLabel: 'ACTIVATE CONNECT',
};

export default CheckoutForm;
